import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ConfigService } from './auth/config.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient, private configService: ConfigService, private router: Router) { }
  getMenuForDropdown() {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMenuForDropDown`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Menu retrieval failed.'));
      })
    );
  }
  addMenu(data:any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/AddMenu`;
    return this.http.post<any>(apiUrl,data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Menu retrieval failed.'));
      })
    );
  }
  getMenuList(data:any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMenu`;
    return this.http.post<any>(apiUrl,data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Menu retrieval failed.'));
      })
    );
  }
  getMenuById(id:any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMenuById?id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Menu retrieval failed.'));
      })
    );
  }
  isActiveMenu(id:any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/IsActiveMenu?id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Menu retrieval failed.'));
      })
    );
  }
  deleteMenu(id:any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/DeleteMenu?id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Role retrieval failed.'));
      })
    );
  }
  getMenuByRoleId(roleId:any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMenuByRoleId?roleId=${roleId}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Menu retrieval failed.'));
      })
    );
  }
//  getMenuByUserId(userId: any) {
//   const apiUrl = `${this.configService.getApiUrl()}/Common/GetMenuByUserId?Id=${userId}`;
  
//   return this.http.get<any>(apiUrl).pipe(
//     map((response) => response),
//     catchError((err) => {
//       console.error('API Error: ', err);
//       return throwError(() => new Error('Menu retrieval failed.'));
//     })
//   );
// }
getMenuByUserId(roleId: number) {
  const apiUrl =
    `${this.configService.getApiUrl()}/Common/GetMenuByRoleId?roleId=${roleId}`;

  const headers = {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  };

  return this.http.get<any>(apiUrl, { headers });
}

 getRoleForDropDown(action: string) {
  const apiUrl = `${this.configService.getApiUrl()}/Common/GetRoleForDropDown?action=${action}`;
  return this.http.get<any>(apiUrl).pipe(
    map((response) => response),
    catchError((err) => {
      console.error('API Error: ', err);
      return throwError(() => new Error('Role retrieval failed.'));
    })
  );
}

  rolePermission(data:any) {

    const apiUrl = `${this.configService.getApiUrl()}/Common/RolePermission`;
    return this.http.post<any>(apiUrl,data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Menu retrieval failed.'));
      })
    );
  }
  userPermission(data:any) {

    const apiUrl = `${this.configService.getApiUrl()}/User/MenuPermission`;
    return this.http.post<any>(apiUrl,data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Menu retrieval failed.'));
      })
    );
  }
  getMenuForHeader() {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetAssignedMenuByUserId`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Menu retrieval failed.'));
      })
    );
  }

}
